export default {
  title: "Buchungen",
  descriptionSeller: "Verwalten Sie alle Buchungen für Ihre Aktivitäten",
  descriptionHost: "Verwalten Sie Buchungen für Ihre Aktivitäten",
  descriptionAdmin:
    "Buchungen und Handshake-Konversationen für diesen Verkäufer anzeigen",
  adminScopeTitle: "Wähle zuerst einen Verkäufer",
  adminScopeAction: "Zu den Benutzern",
  adminScopeRequired:
    "Öffnen Sie die Detailseite eines Verkäufers und nutzen Sie „Buchungen anzeigen“, um dessen Buchungen einzusehen.",
  backToPartner: "Zurück zum Verkäufer",
  descriptionCustomer: "Ihre Buchungen anzeigen und Belege hochladen",
  sellerIdMissing: "Verkäufer-Benutzer-ID nicht gefunden",
  errorLoad: "Fehler beim Laden der Buchungen",
  viewSelectorLabel: "Ansicht",
  viewList: "Liste",
  viewCalendar: "Kalender",
  calendar: {
    previousWeek: "Vorherige Woche",
    nextWeek: "Nächste Woche",
    today: "Heute",
    todayBadge: "Heute",
    openDay: "{{count}} Termine am {{date}} anzeigen",
    emptyDay: "Keine Termine",
    emptyDayDescription: "Für diesen Tag sind keine Buchungen geplant.",
    dayStripEmpty: "—",
    dayStripSummary: "{{bookings}} B. · {{covers}} Pers.",
    daySummaryWithCovers_one: "{{count}} Buchung · {{covers}} Personen gesamt",
    daySummaryWithCovers_other:
      "{{count}} Buchungen · {{covers}} Personen gesamt",
  },
  cardTitle: "Buchungen",
  needsAttention: {
    title: "Handlungsbedarf",
    subtitle_one: "{{count}} Buchung erfordert Ihre Aufmerksamkeit",
    subtitle_other: "{{count}} Buchungen erfordern Ihre Aufmerksamkeit",
    allClearTitle: "Alles erledigt",
    allClearSubtitle: "Derzeit kein Handlungsbedarf",
    seeAllBookings: "Alle Buchungen anzeigen",
    showAll: "Alle anzeigen ({{count}})",
    showAllTitle: "Buchungen mit Handlungsbedarf",
  },
  stats: {
    tile: {
      confirmation: "Zu bestätigen",
      receipts: "Belege hochladen",
      guests: "Gäste heute",
      completion: "Besuche abschließen",
    },
  },
  activityFilter: {
    label: "Aktivität",
    allActivities: "Alle Aktivitäten",
    optionWithCount: "{{name}} ({{count}})",
  },
  statusFilter: {
    label: "Status",
    any: "Alle Status",
    optionWithCount: "{{name}} ({{count}})",
  },
  actionFilters: {
    label: "Nach Aktion filtern",
    all: "Alle Aktionen",
    confirmation: "Bestätigung ausstehend",
    receipt: "Beleg erforderlich",
    completion: "Besuch nicht abgeschlossen",
  },
  manageModal: {
    emptyTitle: "Nichts zu erledigen",
    emptyDescription:
      "Alle Buchungen sind auf dem neuesten Stand — keine Aktionen erforderlich.",
    completeConfirmTitle: "Besuch als abgeschlossen markieren?",
    completeConfirmMessage:
      "Die Buchung wird nach dem Besuch als abgeschlossen markiert.",
  },
  partyItems: {
    andMore_one: "+{{count}} weitere",
    andMore_other: "+{{count}} weitere",
  },
  list: {
    undatedSection: "Kein Besuchsdatum",
  },
  bookingCount_one: "{{count}} Buchung",
  bookingCount_other: "{{count}} Buchungen",
  loading: "Buchungen werden geladen…",
  emptyTitle: "Noch keine Buchungen",
  emptyDescription:
    "Kundenbuchungen erscheinen hier, sobald Sie Ihre erste erhalten",
  emptyFilteredTitle: "Keine Buchungen passen zu diesen Filtern",
  emptyFilteredDescription:
    "Versuchen Sie einen anderen Status oder eine andere Aktivität, oder setzen Sie die Filter zurück.",
  unknownActivity: "Unbekannte Aktivität",
  guest_one: "{{count}} Gast",
  guest_other: "{{count}} Gäste",
  kioskBookingTitle: "Für diese Buchung verwendetes Tablet",
  receiptUploadErrorTitle: "Fehler beim Beleg-Upload",
  receiptUploadErrorMessage:
    "Beim Hochladen oder Analysieren des Belegs ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
  receiptConfirmErrorTitle: "Fehler bei der Belegbestätigung",
  receiptConfirmErrorMessage:
    "Beim Bestätigen des Belegs ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
  toastReceiptAlready: "Für diese Buchung ist bereits ein Beleg registriert.",
  toastPointsAwarded: "Beleg bestätigt! +{{points}} Treuepunkte",
  toastPartnerUploaded: "Beleg erfolgreich hochgeladen. Gesamt: {{total}}",
  receiptOcrUnreadableTitle: "Beleg nicht lesbar",
  receiptOcrUnreadableFallback:
    "Der Gesamtbetrag konnte nicht aus dem Beleg gelesen werden. Bitte fotografieren Sie den Beleg erneut und deutlicher.",
  receiptManualRequiredTitle: "Manueller Gesamtbetrag erforderlich",
  receiptManualCta: "Gesamtbetrag eingeben",
  receiptManualRequiredMessage:
    "Die Versuche zur Belegvalidierung sind aufgebraucht. Geben Sie den Gesamtbetrag manuell ein.",
  toastPartnerManualAmount:
    "Manueller Beleggesamtbetrag gespeichert: {{total}}",
  alertGotIt: "Verstanden",
  emptyDescriptionCustomer:
    "Ihre Buchungen erscheinen hier. Laden Sie Belege von abgeschlossenen Besuchen hoch, um Punkte zu sammeln.",
  status: {
    CREATED: "Zahlung ausstehend",
    PENDING_HANDSHAKE: "Handshake ausstehend",
    ACCEPTED: "Angenommen",
    REJECTED: "Abgelehnt",
    COMPLETED: "Abgeschlossen",
    CANCELED: "Storniert",
    ABANDONED: "Abgelaufen",
    unknown: "Unbekannter Status",
  },
  partnerStatus: {
    pending: "Ausstehend",
    confirmed: "Bestätigt",
  },
  handshake: {
    messageCount_one: "{{count}} Nachricht",
    messageCount_other: "{{count}} Nachrichten",
    loading: "Konversation wird geladen…",
    loadError: "Handshake-Konversation konnte nicht geladen werden",
    notFound: "Handshake-Konversation nicht gefunden",
  },
  detail: {
    loading: "Buchung wird geladen…",
    loadError: "Diese Buchung konnte nicht geladen werden",
    notFound: "Buchung nicht gefunden",
    backToList: "Zurück zu Buchungen",
    orderInfo: "Bestelldetails",
    bookingSummary: "Buchung",
    requestedVisit: "Gewünschtes Datum",
    bookingType: "Buchungstyp",
    bookingTypes: {
      restaurant: "Restaurantbuchungen",
      service: "Dienstleistungsbuchungen",
    },
    handshakeActions: "Aktionen",
    chatSectionTitle: "Handshake-Chat",
    chatChannelCustomer: "{{channel}} — {{name}}",
    chatClosedBadge: "Geschlossen",
    moreActions: "Weitere Aktionen",
    supportHelpAction: "Support-Ticket öffnen",
    supportTicketSubject: "Buchung {{id}}",
    completeSectionTitle: "Besuch abschließen",
    completeSectionDescription:
      "Markiere diese Buchung als abgeschlossen, wenn der Besuch stattgefunden hat.",
    completeSectionAction: "Als abgeschlossen markieren",
    receiptSectionTitle: "Beleg hochladen",
    receiptSectionDescription:
      "Lade ein Foto des Belegs hoch, um diese Buchung abzuschließen und die Provision zu berechnen.",
    receiptManualSectionTitle: "Belegbetrag eingeben",
    receiptManualSectionDescription:
      "Die Validierungsversuche sind aufgebraucht. Gib den Gesamtbetrag manuell ein, um diese Buchung abzuschließen.",
    cancelBookingBusy: "Buchung wird storniert…",
    cancelBookingSuccess: "Buchung storniert",
    cancelBookingError: "Diese Buchung konnte nicht storniert werden",
    cancelBookingPastVisitError:
      "Eine Buchung kann nach dem Besuchsdatum und der -uhrzeit nicht mehr storniert werden",
    cancelBookingConfirmTitle: "Diese Buchung stornieren?",
    cancelBookingConfirmMessage:
      "Der Kunde erhält gegebenenfalls eine Rückerstattung. Dies kann nicht rückgängig gemacht werden.",
        cancelBookingConfirmMessageAdmin:
      "Cancel booking for {{name}} ({{amount}})? The refund starts automatically and cannot be undone.",
cancelBookingConfirmAction: "Buchung stornieren",
    statusInsight: {
      abandonedTitle: "Zahlung abgelaufen",
      abandonedDescription:
        "Der Kunde hat die Zahlung nicht rechtzeitig abgeschlossen. Dies ist keine Stornierung — die Buchung wurde nie bestätigt.",
    },
    cancellationSource: {
      label: "Storniert von",
      customer: "Kunde",
      partner: "Partner",
      system: "System",
    },
    markComplete: "Besuch als abgeschlossen markieren",
    markCompleteBusy: "Wird als abgeschlossen markiert…",
    markCompleteSuccess: "Besuch als abgeschlossen markiert",
    markCompleteError:
      "Diese Buchung konnte nicht als abgeschlossen markiert werden",
    chatViaChannel: "Chat über {{channel}}",
    receipt: "Beleg",
    noHandshake: "Keine Handshake-Konversation für diese Buchung",
    bookingId: "Buchungs-ID",
    services: "Dienstleistungen",
    visitDate: "Besuchsdatum",
    visitTime: "Besuchszeit",
    partySize: "Personenzahl",
    customerName: "Kunde",
    email: "E-Mail",
    phone: "Telefon",
    kiosk: "Tablet / Gerät",
    generatingDevice: "Gerät wird generiert",
    hostingStructure: "Host-Struktur",
    unnamedDevice: "Unbenanntes Gerät",
    total: "Gesamt",
    amountPaid: "Bezahlter Betrag",
    depositPaid: "Anzahlung erhalten",
    dueAtVenue: "Restbetrag vor Ort",
    listPrice: "Listenpreis",
    sellerDiscount: "Partner-Rabatt",
    sellerDiscountBadge: "Partner-Rabatt",
    sellerDiscountNote:
      "Diesen Rabatt hast du gesetzt — deine Auszahlung basiert auf dem Servicepreis nach diesem Abschlag.",
    servicePrice: "Servicepreis",
    flitripDiscount: "Flitrip-Rabatt",
    flitripDiscountBadge: "Flitrip-Rabatt",
    flitripDiscountNote:
      "Deine Auszahlung bleibt auf dem Servicepreis — Flitrip übernimmt diesen Rabatt.",
    pointsDiscount: "Punkterabatt",
    customerPaid: "Kunde gezahlt",
    createdAt: "Gebucht am",
    customerNotes: "Kundennotizen",
    sellerNotes: "Verkäufernotizen",
  },
  adminDetail: {
    tabs: {
      label: "Bereiche der Buchungsdetails",
      overview: "Übersicht",
    },
    ids: {
      title: "Technische Referenzen",
      hint: "Kopierbare IDs für Support und Entwickler",
      handshakeSession: "Handshake-Sitzung",
      externalPayment: "Externe Zahlung",
    },
    localTime: "({{time}} Ortszeit)",
    sections: {
      parties: "Beteiligte",
      customer: "Kunde",
      booking: "Buchung",
      payment: "Zahlung",
      receipt: "Beleg",
      chat: "Handshake-Chat",
    },
    timeline: {
      steps: {
        CREATED: "Erstellt",
        PENDING_HANDSHAKE: "Warten auf Handshake",
        ACCEPTED: "Angenommen",
        COMPLETED: "Abgeschlossen",
        REJECTED: "Abgelehnt",
        CANCELED: "Storniert",
        ABANDONED: "Abgelaufen",
      },
    },
    phone: {
      reveal: "Anzeigen",
      hide: "Ausblenden",
      confirmTitle: "Telefonnummer des Kunden anzeigen?",
      confirmMessage:
        "Der Zugriff auf die Telefonnummer des Kunden wird protokolliert. Zeigen Sie sie nur an, wenn Sie den Kunden für Support kontaktieren müssen.",
      confirmAction: "Telefon anzeigen",
      revealError: "Telefonnummer konnte nicht angezeigt werden",
    },
    partner: {
      activity: "Aktivität",
      name: "Verkäufer",
    },
    payment: {
      none: "Keine externe Zahlung mit dieser Buchung verknüpft",
      noAccess: "Sie haben keine Berechtigung, externe Zahlungen anzuzeigen",
      models: {
        UPFRONT: "Vorauszahlung",
        DEPOSIT: "Anzahlung",
        RECEIPT_BASED: "Belegbasiert",
      },
      amount: "Zahlungsbetrag",
      providerId: "Anbieter-Zahlungs-ID",
      viewPayment: "In Zahlungen anzeigen",
      sellerDiscountNote:
        "Partnerfinanzierter Abschlag — die Partner-Auszahlung basiert auf dem Servicepreis nach diesem Rabatt.",
      flitripDiscountNote:
        "Plattformfinanzierte Promo — die Partner-Auszahlung bleibt auf dem Servicepreis; Flitrip übernimmt diesen Rabatt.",
    },
    economicEvents: {
      title: "Wirtschaftliche Ereignisse",
      none: "Noch keine wirtschaftlichen Ereignisse verknüpft",
      noAccess:
        "Sie haben keine Berechtigung, wirtschaftliche Ereignisse anzuzeigen",
      viewEvent: "Ereignis anzeigen",
    },
    commissions: {
      activityShort: "Aktivität",
      houseShort: "Unterkunft",
    },
    structure: {
      none: "Keine Host-Struktur verknüpft",
      host: "Host",
    },
    language: "Sprache",
    lineItems: {
      qtyUnit: "{{qty}} × {{unit}}",
    },
    receipt: {
      noneYet: "Noch kein Partnerbeleg registriert",
      manualRequired: "Manueller Belegbetrag erforderlich",
      auditTitle: "Verlauf der Beleg-Uploads",
      auditEmpty: "Noch keine Beleg-Uploads",
      viewUpload: "Belegbild anzeigen",
      viewUploadError: "Belegbild konnte nicht geöffnet werden",
      manualRegistered: "Manueller Betrag registriert",
      amountSource: {
        OCR: "Per OCR registriert",
        MANUAL: "Manuell registriert",
      },
      uploadStatus: {
        uploaded: "Hochgeladen",
        ocr_succeeded: "OCR erfolgreich",
        ocr_failed: "OCR fehlgeschlagen",
        partner_rejected: "Vom Partner abgelehnt",
        confirmed: "Bestätigt",
      },
    },
    salesAgent: {
      none: "Dieser Aktivität ist kein Vertriebsagent zugewiesen",
      name: "Vertriebsagent",
    },
    chat: {
      readOnlyHint: "Der Chat ist auf dieser Seite schreibgeschützt.",
    },
  },
  adminReceiptAdjust: {
    title: "Beleggesamtbetrag bearbeiten",
    description:
      "Aktuell registrierter Gesamtbetrag: {{current}}. Die bestehende Gebührenzuordnung wird rückgängig gemacht und eine neue erstellt.",
    amountLabel: "Neuer Beleggesamtbetrag (EUR)",
    amountPlaceholder: "z. B. 125,50",
    reasonLabel: "Grund (optional)",
    reasonPlaceholder: "Warum wird dieser Gesamtbetrag korrigiert?",
    submit: "Neuen Gesamtbetrag speichern",
    action: "Beleggesamtbetrag bearbeiten",
    success: "Beleggesamtbetrag auf {{total}} aktualisiert",
    error: "Beleggesamtbetrag konnte nicht aktualisiert werden",
    invalidAmount: "Geben Sie einen gültigen Betrag größer als null ein",
    sameAmount:
      "Der neue Gesamtbetrag muss sich vom aktuellen Beleggesamtbetrag unterscheiden",
  },
  sellerNotesModal: {
    title: "Verkäufernotizen",
    description:
      "Interne Notizen für Ihr Team. Kunden können diese nicht sehen.",
    placeholder: "Notizen zu dieser Buchung hinzufügen…",
    add: "Notizen hinzufügen",
    edit: "Notizen bearbeiten",
    save: "Notizen speichern",
    saveSuccess: "Verkäufernotizen gespeichert",
    saveError: "Verkäufernotizen konnten nicht gespeichert werden",
    emptyDetail: "Noch keine Verkäufernotizen hinzugefügt.",
  },
} as const;
